<template>
  <section>
    <div class="tip" style="margin:0 0 0 20px">* 款项支付基本资料</div>
    <!-- 新款项支付相关 -->
    <!-- <div class="clear" v-if="form.isAlone">
      <el-form-item label="">
        <el-radio-group v-model="form.isSinglePay" :disabled="hasApplyId" class="type-radio-type">
          <el-radio-button label="0">工程相关款项</el-radio-button>
          <el-radio-button label="1">独立款项</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <div class="clear">
        <el-form-item label="关联工程" v-if="form.isSinglePay==0">
          <el-select size="small" class="project-list-select" clearable v-model="form.projectId"
            @change="onSelectedProject()" filterable placeholder="请选择">
            <el-option v-for="item in projectList" :key="item.id" :label="item.number+'-'+item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付款名称" v-else>
          <el-input size="small" v-model="form.name" placeholder="独立付款的情况请输入付款名称"></el-input>
        </el-form-item>
      </div>
    </div>

    <div class="clear">
      <el-col :span="12">
        <el-form-item class="underline-label" label="已线下通过该审批">
          <el-radio v-model="form.underLine" label="1">是</el-radio>
          <el-radio v-model="form.underLine" label="0">否</el-radio>
          <p class="tip" v-if="form.underLine=='1'" style="padding:0 10px;border:1px #d93c37 solid;">
            *已线下通过的审批须在附件中上传原始审批文件或三重一大会议纪要等相关证明文件，方便领导批阅。</p>
        </el-form-item>
      </el-col>
    </div> -->
    <div class="clear">
      <!-- <el-col :span="12">
        <el-form-item class="important-label" label="*款项类别">
          <el-select size="small" class="project-list-select" v-model="form.payTypeId" filterable placeholder="请选择款项类别"
            style="width:auto;">
            <el-option v-for="item in payTypeList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <router-link v-if="operationType!='show'" to="/Pay/Type" class="link" style="margin-left:15px;">新增款项类别
          </router-link>
        </el-form-item>
      </el-col> -->
      <el-col :span="24">
        <el-form-item label="资金申请单位">
          <el-input size="small" v-model="form.fkdw" placeholder="请输入付款单位"></el-input>
        </el-form-item>
      </el-col>
    </div>

    <div class="clear">
      <el-col :span="12">
        <el-form-item class="important-label" label="*申请金额(元)">
          <el-input size="small" type="number" v-model="form.htjk" placeholder="/">
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item class="important-label" label="*申请金额(大写)">
          <el-input size="small" type="" v-model="form.dxje" placeholder="合同金额(大写)"></el-input>
        </el-form-item>
      </el-col>
    </div>

    <div class="clear">
      <el-form-item label="资金内容">
        <el-input type="textarea" placeholder="资金内容" :autosize="{ minRows: 6, maxRows: 12}" size="small"
          v-model="form.remark"></el-input>
      </el-form-item>
    </div>
  </section>
</template>

<script>
  export default {
    props: ['project', 'formByFather', 'userData', 'operationType', 'hasApplyId'],
    data() {
      return {
        form: {},
        wtfsArr: ["直接委托", "公开招标", "邀请招标"],
        cgfsArr: ["子公司自行采购", "集团自行招标", "公开招标"],

        // 选择项目列表
        projectList: [],
        // 款项支付所属类型
        payTypeList: [],
        // loading状态
        formLoading: false,

        // 是否独立支付支付相关Type
        // isSinglePay: 0,
      }
    },
    created() {
      this.getProjectList()
      this.getPayType()
    },
    mounted() {
      this.form = this.formByFather
      this.form.projectId = this.form.projectId == 0 ? '' : this.form.projectId
      this.form.projectId = this.form.projectId ? this.form.projectId / 1 : ''

      this.form.isSinglePay = this.form.projectId ? 0 : 1
    },
    methods: {
      // 选择了关联工程
      onSelectedProject() {
        // 通过工程ID获取NAME
      },
      // 获取款项支付类型
      getPayType() {
        ajax.get('/pay/type/list', '', (res) => {
          this.payTypeList = res.vo.array
        })
      },
      // 获取项目列表
      getProjectList(cb) {
        ajax.get('/contract/project/choose/list', {
          depId: ''
        }, (res) => {
          this.projectList = res.vo.array
          cb && cb()
        })
      },
      getFromData() {
        if (!this.form.remark) {
          this.$message.error("资金内容不能为空")
          return
        }
        if (this.form.dxje === '') {
          this.$message.error("所有标红项目均是必填项，请仔细检查您的填写内容")
          return
        }

        this.form.bqzf = this.form.htjk
        this.form.zfzshzj = 100
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      },

    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/createPayYsApproval.vue